import React from 'react';

const NgHowItWorksSection = () => {
  const platforms = [
    { name: 'Moniepoint', logo: '/moniepoint-logo.png' },
    { name: 'OPay', logo: '/opay-logo.png' },
    { name: 'PalmPay', logo: '/palmpay-logo.png' },
    { name: 'Nomba', logo: '/nomba-logo.png' },
  ];

  const channels = [
    { name: 'WhatsApp', logo: '/whatsapp-logo.png' },
    { name: 'SMS', logo: '/sms-logo.png' },
    { name: 'Facebook', logo: '/facebook-logo.png' },
    { name: 'Instagram', logo: '/instagram-logo.png' },
  ];

  const steps = [
    {
      step: 'Step 1',
      title: 'Connect your POS & payment platforms',
      body:
        'Link Moniepoint, OPay, PalmPay, and Nomba in a few clicks. No engineers. No spreadsheets. Just a clean, real-time stream of transaction data.',
    },
    {
      step: 'Step 2',
      title: 'AI finds money hiding in your data',
      body:
        'The AI scans every transaction in real time, finds deep patterns (who buys every 14 days, who spends more on weekends, who ghosts after one purchase) and builds profitable customer segments for you.',
    },
    {
      step: 'Step 3',
      title: 'Autopilot campaigns across WhatsApp, SMS & ads',
      body:
        'Kolanut.ai writes and sends hyper-personalized WhatsApp flows, SMS reorder nudges, and Facebook/Instagram ad creatives that actually convert — no “Dear Valued Customer”, just real messages that feel human.',
    },
  ];

  return (
    <section id="how-it-works" className="py-12 sm:py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-black/70 mb-3">
            How It Works
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-black mb-3">
            Kolanut.ai is the AI marketing copilot built exclusively for Nigerian merchants.
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
            It connects directly to your existing POS and payment platforms in under 60 seconds — then goes to work.
          </p>
        </div>

        <div className="rounded-[2rem] border border-gray-200 bg-white p-5 sm:p-6 mb-6 shadow-[0_20px_45px_-18px_rgba(0,0,0,0.12)]">
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black/70 mb-3">
                Data sources
              </p>
              <div className="grid grid-cols-2 gap-3">
                {platforms.map((platform) => (
                  <div
                    key={platform.name}
                    className="rounded-2xl border border-gray-200 bg-gray-50 px-4 py-4 min-h-[122px] flex flex-col items-center justify-center text-center"
                  >
                    <img
                      src={platform.logo}
                      alt={`${platform.name} logo`}
                      className="h-10 sm:h-12 w-auto object-contain mb-2"
                    />
                    <span className="text-sm font-semibold text-black leading-tight">{platform.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-black/70 mb-3">
                Channels
              </p>
              <div className="grid grid-cols-2 gap-3">
                {channels.map((channel) => (
                  <div
                    key={channel.name}
                    className="rounded-2xl border border-gray-200 bg-white px-4 py-4 min-h-[122px] flex flex-col items-center justify-center text-center"
                  >
                    <img
                      src={channel.logo}
                      alt={`${channel.name} logo`}
                      className="h-10 sm:h-12 w-auto object-contain mb-2"
                    />
                    <span className="text-sm font-semibold text-black leading-tight">{channel.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* <p className="text-xs text-gray-500 mt-4">
            Assumed asset paths: `public/moniepoint-logo.png`, `public/opay-logo.png`, `public/palmpay-logo.png`,
            `public/nomba-logo.png`, `public/whatsapp-logo.png`, `public/sms-logo.png`, `public/facebook-logo.png`,
            `public/instagram-logo.png`
          </p> */}
        </div>

        <div className="grid gap-6 md:grid-cols-3">
          {steps.map((item, index) => (
            <div
              key={item.step}
              className={`rounded-[2rem] px-5 py-6 border shadow-sm ${
                index === 1
                  ? 'bg-black text-white border-black shadow-[0_24px_60px_-24px_rgba(0,0,0,0.35)]'
                  : 'bg-white text-black border-gray-200'
              }`}
            >
              <div className="flex items-center justify-between mb-4">
                <p className={`text-xs font-semibold uppercase tracking-[0.18em] ${index === 1 ? 'text-white/70' : 'text-black/70'}`}>
                  {item.step}
                </p>
                <div
                  className={`h-10 w-10 rounded-full flex items-center justify-center text-sm font-bold ${
                    index === 1 ? 'bg-[#8ae690] text-black' : 'bg-black text-white'
                  }`}
                >
                  {index + 1}
                </div>
              </div>
              <h3 className={`text-lg font-semibold mb-3 ${index === 1 ? 'text-white' : 'text-black'}`}>
                {item.title}
              </h3>
              <p className={`text-sm leading-relaxed ${index === 1 ? 'text-white/85' : 'text-gray-700'}`}>
                {item.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NgHowItWorksSection;

